import type { ElectronContext } from '@mimir/common/context/applicationContext';
import type { LauncherParams } from '../driver-common/launcher-params';
import { dvrState, type DvrConfig } from './config';
import type { NleAsset } from '@mimir/common/dto/tenantModel';
import { getScriptString } from './script';
import { startLauncher } from '../driver-common/launcher';
import type { Logger } from '@mimir/common/types/logger';

export const launchStep = (
  applicationContext: ElectronContext,
  launcherParams: LauncherParams,
  pythonPath: string,
) => {
  const rendererProcess = applicationContext.mainRequire('child_process').execFile(
    launcherParams.encoderExePath,
    launcherParams.encoderExeArgs,
  );
  console.debug(`Started new renderer process: ${rendererProcess.pid}`);
  console.debug(`Starting new Python process ${pythonPath} "${launcherParams.tempScriptFilePath}"`);
  const pythonProcess = applicationContext.mainRequire('child_process').execFile(
    pythonPath,
    [launcherParams.tempScriptFilePath],
    (err: any, stdout: any, stderr: any) => {
      console.debug(`Python(${pythonProcess.pid}): ${JSON.stringify({ err: `${err}`, stdout, stderr })}`);
    }
  );
  console.debug(`Python process: ${pythonProcess.pid}`);

  return rendererProcess;
};

export const launchWithConfig = (
  services: {
    applicationContext: ElectronContext,
    logger: Logger,
    getDownloadPath: () => string,
  },
  dvrConfig: DvrConfig,
) => {
  startLauncher(
    services,
    {
      enabled: dvrConfig.enabled,
      encoderExePath: dvrConfig.dvrPath,
      encoderExeArgs: dvrConfig.headless ? ['-nogui'] : [],
      selectedWatchFolders: dvrConfig.selectedWatchFolders,
      projectFileExtension: '.drp',
      processName: 'Resolve',
      doesPresetMatch: (presetName: string, preset: NleAsset) => preset.nleType === 'dvr' && (preset.name === presetName || preset.name === `${presetName}.xml`),
      rendererLaunchStep: (applicationContext: ElectronContext, launcherParams: LauncherParams) => launchStep(applicationContext, launcherParams, dvrConfig.pythonPath),
      getScriptString: getScriptString,
      scriptFileExtension: 'py',
    },
    dvrState,
  );
};
